import React, { useRef } from "react";
import { blackAlpha008, lightInactive, onHoverDropShadow } from "../variable";
import { CheckboxComponent, EmptyScreenComponent } from "./stylesHome";
import emptyScreenImage from "../../../assets/images/empty-state.svg";
import { Link } from "react-router-dom";
import {
  Button,
  Tooltip,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Divider,
  FormControl,
  Input,
  Icon,
  ModalCloseButton,
  ButtonGroup,
  IconButton,
  Portal,
} from "@chakra-ui/react";
import {
  FaCheckCircle,
  FaRegCircle,
  FaCommentDots,
  FaRobot,
  FaArrowCircleRight,
} from "react-icons/fa";
import { useTranslation } from "react-i18next";

export const folderComponentStyles = {
  border: `3px solid ${blackAlpha008}`,
  maxHeight: "51px",
  height: "51px",
  backgroundColor: "brand.dark_02",
  borderRadius: "24px",
  padding: "10px 5px 10px 20px",
  color: "gray.100",
  ":hover": {
    cursor: "pointer",
    border: `3px solid`,
    borderColor: "brand.grey-darker",
    boxShadow: `0px 0px 40px ${onHoverDropShadow}`,
    "-webkit-box-shadow": `0px 0px 40px ${onHoverDropShadow}`,
    " -moz-box-shadow": `0px 0px 40px ${onHoverDropShadow}`,
  },
};

export const TldrCheckbox = (props) => {
  const { hasAbsolutePosition, description, checked, onCheck } = props;

  return (
    <CheckboxComponent hasAbsolutePosition={hasAbsolutePosition}>
      <Tooltip label={description} hasArrow shouldWrapChildren>
        <Icon
          as={checked ? FaCheckCircle : FaRegCircle}
          color={lightInactive}
          boxSize={4}
          onClick={(e) => {
            e.stopPropagation();
            onCheck(!checked);
          }}
        />
      </Tooltip>
    </CheckboxComponent>
  );
};

export const TldrNewFolderDialog = (props) => {
  const { show, onHide, inProgress, rename } = props;
  const [value, setValue] = React.useState(props.value ? props.value : "");
  const innerRef = useRef();
  const { t } = useTranslation(["folders", "common"]);

  return (
    <Modal
      isOpen={show}
      onClose={onHide}
      isCentered
      size="sm"
      initialFocusRef={innerRef}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          {rename ? t("rename_folder.message") : t("create_folder.message")}
        </ModalHeader>
        <Divider my="1" />
        <ModalCloseButton />
        <ModalBody>
          <FormControl>
            <Input
              ref={innerRef}
              placeholder={t("folder_name")}
              value={value}
              onChange={(e) => setValue(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  if (value.trim().length > 0) props.onYes(value);
                }
              }}
            />
          </FormControl>
        </ModalBody>
        <Divider my="1" />

        <ModalFooter>
          <ButtonGroup>
            <Button
              onClick={(e) => {
                e.stopPropagation();
                props.onHide();
              }}
              variant="secondary"
              disabled={inProgress ? true : false}
            >
              {t("cancel", { ns: "common" })}
            </Button>

            <Button
              onClick={(e) => {
                e.stopPropagation();
                if (value.trim().length > 0) props.onYes(value);
              }}
              variant="solid"
              isLoading={inProgress}
              loadingText={rename ? t("applying") : t("creating")}
            >
              {!inProgress && `${rename ? t("apply") : t("create")}`}
            </Button>
          </ButtonGroup>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export const EmptyStateScreen = (props) => {
  const {
    className,
    textAlign,
    title,
    description,
    link,
    linkPlaceholder,
    actionButtonOnClick,
    actionButtonPlaceholder,
  } = props;

  return (
    <EmptyScreenComponent className={`${className}`}>
      <h1 style={{ textAlign: textAlign ? textAlign : "left" }}>{title}</h1>
      <img src={emptyScreenImage} alt="Empty State" />
      <p className="description">{description}</p>
      {link ? (
        <Link to={link} style={{ textDecoration: "underline" }}>
          {linkPlaceholder}
        </Link>
      ) : null}
      {actionButtonOnClick ? (
        <Button
          mt={2}
          rightIcon={<FaArrowCircleRight></FaArrowCircleRight>}
          onClick={actionButtonOnClick}
          variant="solid"
        >
          {actionButtonPlaceholder}
        </Button>
      ) : null}
    </EmptyScreenComponent>
  );
};

export const IntercomCustomIcon = ({ position }) => {
  const { t } = useTranslation(["common"]);
  return (
    <Portal>
      <Tooltip label={t("contact_us")} hasArrow>
        <IconButton
          id="chatonintercom"
          position={position}
          action="intercom"
          icon={<FaCommentDots style={{display:"inline"}}/>}
          variant="solid"
          borderRadius="full"
          bottom={5}
          right={5}
          zIndex={1100}
          display={["none", "none", "block", "block"]}
          verticalAlign="middle"
         
        />
      </Tooltip>
    </Portal>
  );
};

export const AiAssistantIcon = ({ onClick, bottom }) => {
  const { t } = useTranslation(["common"]);
  return (
    <Tooltip hasArrow label="AI Assistant" placement="top">
      <IconButton
        icon={<FaRobot size="1.2em" />}
        variant="solid"
        borderRadius="full"
        action="airesults"
        onClick={() => onClick()}
        bottom={3}
        right={3}
        size="lg"
        position="absolute"
      />
    </Tooltip>
  );
};
